import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ReactSVG from "react-svg";
import Media from "react-responsive";
import { xMediumScreen } from "@styles/constants";
import { Loader } from "@components/atoms";
import { StatusData, StatusDataFooter } from "@components/molecules";
import { useOrder } from "@saleor/sdk";
import { GatewayTypesEnum, PaymentChargeStatusEnum } from "@globalTypes/globalTypes";
import { getErrorMessage } from "@temp/intl";
import * as S from "./styles";
import waitingImg from "../../../../images/timeout.svg";
import goBackImg from "../../../../images/arrowBack.svg";

/**
 * timeout status structure
 */
var StatusTimeOut = function StatusTimeOut(_ref) {
  var _data$paymentStatus, _PaymentChargeStatusE, _data$paymentStatus2, _data$paymentStatus3, _data$paymentStatus4, _PaymentChargeStatusE2, _data$paymentStatus5, _PaymentChargeStatusE3, _data$paymentStatus6, _PaymentChargeStatusE4;

  var data = _ref.data,
      goBack = _ref.goBack;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      errors = _React$useState4[0],
      setErrors = _React$useState4[1];

  var intl = useIntl();

  var _useOrder = useOrder(),
      orderAgain = _useOrder.orderAgain,
      orderCancelRefund = _useOrder.orderCancelRefund;

  var handleOrderAgain = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _dataError$error;

      var _yield$orderAgain, dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return orderAgain(data === null || data === void 0 ? void 0 : data.id);

            case 3:
              _yield$orderAgain = _context.sent;
              dataError = _yield$orderAgain.dataError;

              if ((dataError === null || dataError === void 0 ? void 0 : (_dataError$error = dataError.error) === null || _dataError$error === void 0 ? void 0 : _dataError$error.length) > 0) {
                setErrors(dataError === null || dataError === void 0 ? void 0 : dataError.error);
              }

              setLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOrderAgain() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleOrderCancelRefund = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return orderCancelRefund(data === null || data === void 0 ? void 0 : data.id);

            case 3:
              setLoading(false);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleOrderCancelRefund() {
      return _ref3.apply(this, arguments);
    };
  }();

  return React.createElement(S.Wrapper, null, React.createElement(S.Tile, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(S.Title, null, React.createElement(S.BackTitle, {
    onClick: goBack
  }, React.createElement(ReactSVG, {
    path: goBackImg
  }), React.createElement(S.BackTitleParragraph, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3471378517",
    defaultMessage: "back"
  }))), React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3509510263",
    defaultMessage: "TIMEOUT"
  })))), React.createElement(S.Content, null, React.createElement(Media, {
    maxWidth: xMediumScreen
  }, React.createElement(S.Title, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3509510263",
    defaultMessage: "TIMEOUT"
  }))), React.createElement(S.ContentContainer, {
    paymentButtons: (data === null || data === void 0 ? void 0 : (_data$paymentStatus = data.paymentStatus) === null || _data$paymentStatus === void 0 ? void 0 : _data$paymentStatus.toUpperCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE = PaymentChargeStatusEnum.FULLY_CHARGED) === null || _PaymentChargeStatusE === void 0 ? void 0 : _PaymentChargeStatusE.toUpperCase()) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && new Date(data === null || data === void 0 ? void 0 : data.lastUpdatedAt).getTime() + 60 * 1000 * (data === null || data === void 0 ? void 0 : data.orderAgainPaidTime) >= new Date().getTime() || (data === null || data === void 0 ? void 0 : data.paymentGateway) !== (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && new Date(data === null || data === void 0 ? void 0 : data.lastUpdatedAt).getTime() + 60 * 1000 * (data === null || data === void 0 ? void 0 : data.orderAgainNotOnlinePaymentTime) >= new Date().getTime() || (errors === null || errors === void 0 ? void 0 : errors.length) > 0 || ((data === null || data === void 0 ? void 0 : (_data$paymentStatus2 = data.paymentStatus) === null || _data$paymentStatus2 === void 0 ? void 0 : _data$paymentStatus2.toUpperCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : PaymentChargeStatusEnum.FULLY_REFUNDED) || (data === null || data === void 0 ? void 0 : (_data$paymentStatus3 = data.paymentStatus) === null || _data$paymentStatus3 === void 0 ? void 0 : _data$paymentStatus3.toUpperCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : PaymentChargeStatusEnum.REFUND_FAILED)) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO)
  }, React.createElement(S.Images, null, React.createElement(ReactSVG, {
    path: waitingImg
  })), React.createElement(S.Parragraph, {
    "data-test": "checkoutPageSubtitle"
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.49907891",
    defaultMessage: "the establishment did not respond to the order request"
  })), (data === null || data === void 0 ? void 0 : (_data$paymentStatus4 = data.paymentStatus) === null || _data$paymentStatus4 === void 0 ? void 0 : _data$paymentStatus4.toUpperCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE2 = PaymentChargeStatusEnum.REFUND_FAILED) === null || _PaymentChargeStatusE2 === void 0 ? void 0 : _PaymentChargeStatusE2.toUpperCase()) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && React.createElement(S.ParragraphLetter, null, React.createElement(S.Span, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.1448548847",
    defaultMessage: "We are processing the refund"
  }))), (data === null || data === void 0 ? void 0 : (_data$paymentStatus5 = data.paymentStatus) === null || _data$paymentStatus5 === void 0 ? void 0 : _data$paymentStatus5.toUpperCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE3 = PaymentChargeStatusEnum.FULLY_REFUNDED) === null || _PaymentChargeStatusE3 === void 0 ? void 0 : _PaymentChargeStatusE3.toUpperCase()) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && React.createElement(S.ParragraphLetter, null, React.createElement(S.Span, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3944098690",
    defaultMessage: "Your payment has been refunded*"
  })), React.createElement(S.SpanMessages, null, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.789861204",
    defaultMessage: "*Refund times will depend on your bank"
  }))), (data === null || data === void 0 ? void 0 : (_data$paymentStatus6 = data.paymentStatus) === null || _data$paymentStatus6 === void 0 ? void 0 : _data$paymentStatus6.toUpperCase()) === (PaymentChargeStatusEnum === null || PaymentChargeStatusEnum === void 0 ? void 0 : (_PaymentChargeStatusE4 = PaymentChargeStatusEnum.FULLY_CHARGED) === null || _PaymentChargeStatusE4 === void 0 ? void 0 : _PaymentChargeStatusE4.toUpperCase()) && (data === null || data === void 0 ? void 0 : data.paymentGateway) === (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && new Date(data === null || data === void 0 ? void 0 : data.lastUpdatedAt).getTime() + 60 * 1000 * (data === null || data === void 0 ? void 0 : data.orderAgainPaidTime) >= new Date().getTime() && React.createElement(S.Buttons, null, React.createElement(S.Button, {
    onClick: handleOrderAgain
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3064572375",
    defaultMessage: "order again"
  })), React.createElement(S.Button, {
    onClick: handleOrderCancelRefund
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3181192419",
    defaultMessage: "cancel order and request refund"
  }))), (data === null || data === void 0 ? void 0 : data.paymentGateway) !== (GatewayTypesEnum === null || GatewayTypesEnum === void 0 ? void 0 : GatewayTypesEnum.ONLINE_CREDIBANCO) && new Date(data === null || data === void 0 ? void 0 : data.lastUpdatedAt).getTime() + 60 * 1000 * (data === null || data === void 0 ? void 0 : data.orderAgainNotOnlinePaymentTime) >= new Date().getTime() && React.createElement(S.Buttons, null, React.createElement(S.Button, {
    onClick: handleOrderAgain
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.StatusTimeOut.StatusTimeOut.3064572375",
    defaultMessage: "order again"
  }))), errors.length > 0 && React.createElement(S.Errors, null, errors.map(function (error, index) {
    return React.createElement(S.Error, {
      key: index
    }, error && (error === null || error === void 0 ? void 0 : error.code) ? getErrorMessage(error.code, intl) : "");
  })))), React.createElement(S.Aside, null, React.createElement(StatusData, {
    deliveryPhone: false,
    data: data,
    deliveryData: true
  })), React.createElement(S.Footer, null, React.createElement(Media, {
    minWidth: xMediumScreen
  }, React.createElement(StatusDataFooter, {
    data: data
  }))), loading && React.createElement(S.Loader, null, React.createElement(Loader, {
    fullScreen: true
  })));
};

export { StatusTimeOut };